import {
	Component,
	OnInit,
	Input,
	Output,
	SimpleChanges,
	ElementRef,
	EventEmitter,
	OnChanges,
} from "@angular/core";

@Component({
	selector: "app-successor-notification",
	templateUrl: "./successor-notification.directive.html",
	styleUrls: ["./successor-notification.directive.css"],
})
export class SuccessorNotificationDirective implements OnInit {
	@Input() show: boolean;
	@Input() isCorrect: boolean;
	@Input() label: string;
	@Input() bShowfeedBack: boolean;
	@Input() textDirection: string;

	@Output() notificationClosed: EventEmitter<any> = new EventEmitter<any>();
	public enableIphone: Boolean;
	constructor(private elementRef: ElementRef) {
		console.log("SuccessorNotificationDirective");
	}
	ngOnInit() {
		this.show = false;
		this.bShowfeedBack = true;
		if (/iPhone/i.test(navigator.userAgent)) {
			this.enableIphone = true;
		} else {
			this.enableIphone = false;
		}
	}
	ngOnChanges(changes) {
		if (
			changes.hasOwnProperty(`show`) &&
			changes[`show`][`currentValue`] !== undefined &&
			changes[`show`][`currentValue`] === true
		) {
			// this.addIntervalToHide();
		}
	}
	// feedBackCloseHandler(){
	//     this.bShowfeedBack=false;
	//      }
	// protected addIntervalToHide()
	// {
	//     let _owner : any = this;
	//     setTimeout(() => {
	//      _owner.show = false;
	//       _owner.notificationClosed.emit('closed');
	//     }, 2000 );
	// }
}
